import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("img", {
        staticClass: "mb-4 news-image",
        attrs: {
          src: _vm.newsItem.publisher.logo.url,
          alt: _setup.t("Изображение автора", _setup.options),
          width: "100%",
          height: "120px",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-subtitle-1 text--text mb-4 px-2" }, [
        _vm._v("\n    " + _vm._s(_vm.newsItem.header) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-1 text--text mb-4 px-2" }, [
        _vm._v("\n    " + _vm._s(_setup.newsItemText) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.newsItem.text.length > 100
        ? _c(
            VBtn,
            {
              staticClass: "primary--text",
              attrs: { text: "" },
              on: { click: _setup.toggleShowMore },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _setup.isShowMore
                      ? _setup.t("Скрыть", _setup.options)
                      : _setup.t("Показать всё", _setup.options)
                  ) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }